<template>
  <div class="guided-search-content__stepper">
    <a class="guided-search-content__link" href="/">
      <Icon
        :svg="IconLogo"
        width="76"
        height="40"
      />
    </a>
    <horizontal-stepper
      class="gs-stepper__horizontal"
      :steps="store.steps"
      :actual-step="actualStep"
      stepper-type="guided-search"
      :icon-info="false"
    />
  </div>
</template>

<script>
import HorizontalStepper from '@components/HorizontalStepper.vue';
import Icon from '@components/Icon.vue';
import { IconLogo } from '@icons';
import { guidedSearchMixin } from './guidedSearchMixin';

export default {
  components: { Icon, HorizontalStepper },
  mixins: [ guidedSearchMixin ],
  setup() {
    return {
      IconLogo,
    };
  },
};
</script>
